import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Modal, Text } from '@Sage/hoi-poi-ui';
import Illustrations from './components/Illustrations';

import styles from './styles/ModalDisableAddOn';

const { DisableAddOn } = Illustrations;
const useStyles = createUseStyles(styles, 'ModalDisableAddOn');

const ModalDisableAddOn = memo(({ children, content, customImage, ...props }) => {
    const classes = useStyles();

    const modalProps = useMemo(() => {
        return {
            size: 'small',
            ...props,
        };
    }, [props]);

    const Img = useMemo(() => customImage || DisableAddOn, [customImage]);

    return (
        <Modal {...modalProps}>
            <figure className={classes.figure}>
                <Img />
            </figure>
            <div className={classes.content}>
                {content?.length &&
                    content.map((text, index) => (
                        <Text type="body" key={index}>
                            {text}
                        </Text>
                    ))}
            </div>
        </Modal>
    );
});

ModalDisableAddOn.propTypes = {
    content: PropTypes.arrayOf(PropTypes.string),
    customImage: PropTypes.node,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
};

export default ModalDisableAddOn;
